import React, { useMemo, useState } from "react";
import { getDepositedListApi } from "../api/deposits.mock";

import DocumentViewer from "../../receipt/components/DocumentViewerModal";
import DepositedSlipsList from "../components/DepositedSlipsList";
import { useFetchList } from "../../hooks/useFetchList";
import StudentSearchBar from "../../components/StudentSearchBar";
import ReceiptFiltersDrawer from "../../receipt/components/ReceiptFiltersDrawer";
import { useFetchDropdown } from "../../receipt/hooks/useDropdown";
import { updateRequest } from "../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import TopHeaderBar from "../../components/TopHeaderBar";

import { useParams } from "react-router";
import { useNavigateToGivenPath } from "views/pages/manage/edpOps/studentDetails/paymentSummary/service";
import { replaceEmptyWithNull } from "../../../utils";
import DepositedSlipFilterDrawer from "../components/DepositedSlipFilterDrawer";
import ALoader from "../../../../../views/pages/manage/common/a-loader";
import { useBuTypeNameByBuId } from "../../hooks/useFetchBuType";

const SEARCH_BY = [{ key: "depositSlipId", value: "By Deposit Slip ID" }, { key: "createdBy", value: "Cashier ID" }];
const ViewDepositsPage = () => {
  const { id: businessArea } = useParams();
  const { buTypeName, loading: isHookLoading } = useBuTypeNameByBuId(businessArea)
  const headerData = useMemo(
    () => ({
      Type: buTypeName,
      "BU":businessArea
    }),
    [buTypeName]
  );

  const navigate = useNavigateToGivenPath();
  const dropdownValues = useFetchDropdown();
  const [searchInput, setSearchInput] = useState("");
  const [searchBy, setSearchBy] = useState("depositSlipId");
  const {
    rows,
    loading,
    pagination,
    onPageChange,
    onPageSizeChange,
    filters,
    setFilters,
    onFilterApply,
  } = useFetchList(getDepositedListApi, {
    businessAreaId: businessArea,
    initialPageSize: 100,
  });

  const updatedPagination = {
    ...pagination,
    page: pagination.page + 1,
  };

  const [viewer, setViewer] = useState({
    open: false,
    s3key: "",
  });

  const applyFilterHandler = (newFilter) => {
    onFilterApply(updateRequest(newFilter));
  };

  const applyPrimaryFilter = () => {
    onFilterApply(replaceEmptyWithNull({ [searchBy]: searchInput }));
  };

  const removeFilterFormHandler = () => {
    onFilterApply({});
  };

  const onViewSlip = (row) => {
    setViewer({ open: true, s3key: row.slipS3Key });
  };
  const onEditReceipt = (row) => {
    navigate(
      `/admin/cash-management/editCashDeposit/${businessArea}/${row.id}?depositSlipId=${encodeURIComponent(row?.depositSlipId)}`
    );
  };

  return (
    <div className="remove-container-top-space">
      <TopHeaderBar title="Receipts" headerData={headerData} />
      {(loading||isHookLoading) && <ALoader position="fixed" />}
      <div className="a-card p-3">
        <div className="d-flex justify-content-between mb-3">
          <div className="heading-3 color-black semi-bold">
            Deposited slips{" "}
          </div>
          <div className="d-flex gap-md ">
            <div>
              <StudentSearchBar
                searchValue={searchInput}
                onChange={(val) => setSearchInput(val)}
                onKeyDown={applyPrimaryFilter}
                onSearchClick={applyPrimaryFilter}
                dropdownValue={searchBy}
                onDropdownChange={setSearchBy}
                dropdownStyles={{ fontSize: "12px" }}
                dropdownOptions={SEARCH_BY}
              />
            </div>
            <DepositedSlipFilterDrawer
              applyFilterHandler={applyFilterHandler}
              appliedForm={filters}
              dropdownValues={dropdownValues}
              onRemoveFilterHandler={removeFilterFormHandler}
            />
          </div>
        </div>
        <DepositedSlipsList
          rows={rows}
          loading={loading}
          pagination={updatedPagination}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          onViewSlip={onViewSlip}
          onEditReceipt={onEditReceipt}
        />

        <DocumentViewer
          open={viewer.open}
          onClose={() => setViewer({ open: false, s3key: "" })}
          s3Key={viewer.s3key}
        />
      </div>
    </div>
  );
};

export default ViewDepositsPage;
